export default __webpack_public_path__ + "static/media/bbva-logo.5a5da66c.png";